module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/chat/chat.component.css
// module id = ./src/app/components/chat/chat.component.css
// module chunks = main